import { defineComponent, ref, reactive, inject } from 'vue';
import { Search, ArrowDown } from '@element-plus/icons-vue';
import { setStorage, getStorage } from '@/plugins/store';
export default defineComponent({
  components: {
    Search,
    ArrowDown
  },
  props: {
    pageUrl: String
  },
  setup(props, context) {
    const {
      emit
    } = context;
    const $http = inject('$http');
    const $utils = inject('$utils');

    // 搜索
    const searchKey = ref('');
    function search() {
      context.emit('search', searchKey.value);
    }

    // 获取项目基本信息
    const projectInfo = ref(null);
    const getBaseInfo = () => {
      projectInfo.value = getStorage('projectBaseData');
      console.log('projectInfo', projectInfo.value);
    };
    getBaseInfo();

    // 获取用户信息
    const userInfo = ref(null);
    async function getUserInfo() {
      let token = $utils.getCookie('X-Access-Token');
      let ticket = $utils.getUrlParams('ticket');
      if (token) {
        const res = await $http.getUserInfo();
        userInfo.value = res;
        setStorage('userInfo', res);
        emit('change', res);
        return;
      }
      return null;
    }
    getUserInfo();
    // ticket校验
    const noTicketUrl = ref($utils.removeUrlParam(['ticket']));

    // 我的案例
    const gotoMyCase = () => {
      let host = window.location.protocol + '//' + window.location.host;
      window.open(`${host}/admin/`);
    };

    // 退出登录
    const logout = () => {
      //
      $http.logOut().then(res => {
        console.log('logout', res);
        $utils.delCookie('X-Access-Token');
        window.location.href = `/login.html?service=${encodeURIComponent(window.location.href)}`;
      });
    };

    // 统计点击量
    const saveClickCount = async userId => {
      let params = {
        loginUserId: userInfo.id || undefined,
        clickEnum: 'PAGE'
      };
      await $http.saveBrowseClick(params);
    };
    saveClickCount();
    return {
      projectInfo,
      gotoMyCase,
      logout,
      searchKey,
      userInfo,
      noTicketUrl,
      search,
      getUserInfo
    };
  },
  computed: {
    CurrentUrl() {
      return this.pageUrl || window.location.href;
    },
    loginUrl() {
      return `/login.html?service=${this.noTicketUrl}`;
      // return `https://passport.zhihuishu.com/login?source=3&service=${this.noTicketUrl}`;
    }
  }
});